module.exports = __webpack_public_path__ + "media/packs/images/metrics/price-0378a4b062d4ab55d97797263764ad25.svg";